import React from "react";
import Box from "@material-ui/core/Box";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const EvalBarChart = ({ totalData }) => {
  return (
    <Box display="flex" p={1} mt={4} mb={4} style={{ height: 500 }}>
      <Box
        p={1}
        flex={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={750}
            height={500}
            data={totalData}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="1 1" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip cursor={{ fill: "rgb(158 158 158 / 7%)" }} />
            <Legend />
            <Bar
              dataKey="폐암"
              stackId="a"
              barSize={30}
              fill="rgb(0, 136, 254)"
            />
            <Bar
              dataKey="전립선암"
              stackId="a"
              barSize={30}
              fill="rgb(0, 196, 159)"
            />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default EvalBarChart;
